const encodeParam = (param, routerKey) => (param ? encodeURIComponent(param) : `:${routerKey}`);

export const AppRoutes = {
    callback: '/callback',
    loggedOut: '/logged-out',
    home: '/home',
    referralsList: '/referrals',
    referralRedirect: (referralId) => `/referrals/${encodeParam(referralId, 'referralId')}`,
    referralDetails: (payerId, referralId) =>
        `/referrals/${encodeParam(payerId, 'payerId')}/${encodeParam(referralId, 'referralId')}`,
    allMessages: '/messages',
    treatmentSearch: '/treatment-search',
    conversationDetails: (displayId) => `/messages/${encodeParam(displayId, 'displayId')}`,
    treatmentDetails: (payerId, treatmentId) =>
        `/treatments/${encodeParam(payerId, 'payerId')}/${encodeParam(treatmentId, 'treatmentId')}`,
    opportunitiesList: '/opportunities',
    opportunityDetails: (referralId) => `/opportunities/${encodeParam(referralId, 'referralId')}`,
    requests: '/requests',
    requestsList: '/requests/open',
    requestsResolved: '/requests/resolved',
    tools: '/tools',
    priorAuthorization: '/tools/prior-authorization',
    testReferral: '/tools/test-referral',
    bulkTransfer: '/tools/bulk-transfer',
    bulkTransition: '/tools/bulk-transition',
    bulkUnmanage: '/tools/bulk-unmanage',
    bulkAdHocValueCase: '/tools/bulk-ad-hoc-value-case',
    bulkUpdateReferralExpiration: '/tools/bulk-update-referral-expiration',
    closeClaims: '/tools/close-claims',
    treatmentMergeCases: '/tools/treatment-merge-cases',
    payerTreatmentMergeCases: (payerId) =>
        `/tools/treatment-merge-cases/${encodeParam(payerId, 'payerId')}`,
    treatmentMergeCaseDetails: (payerId, caseId) =>
        `/tools/treatment-merge-cases/${encodeParam(payerId, 'payerId')}/${encodeParam(caseId, 'caseId')}`,
    ortfProcessing: '/tools/ortf-processing',
    goLivePlanning: '/go-live-planning',
    upcomingTreatments: '/go-live-planning/upcoming-treatments',
    batchesAndScheduling: '/go-live-planning/batches-and-scheduling',
    termsOfUse: '/terms-of-use',
    privacyPolicy: '/privacy-policy',
    updatesHistory: '/updates-history',
};
